import { render, staticRenderFns } from "./primary.vue?vue&type=template&id=3fb5729a&scoped=true&"
import script from "./primary.vue?vue&type=script&lang=js&"
export * from "./primary.vue?vue&type=script&lang=js&"
import style0 from "./primary.vue?vue&type=style&index=0&id=3fb5729a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb5729a",
  null
  
)

export default component.exports